import * as Yup from 'yup';

import Address from '../entities/address.entity';
import Condominium from '../entities/condominium.entity';

export type CondominiumForm = Condominium;

export type CondominiumFormShape = {
  [key in keyof CondominiumForm]?: any;
};

type AddressShape = {
  [key in keyof Address]?: any;
};

export const schema = Yup.object().shape<CondominiumFormShape>({
  name: Yup.string().required('Digite um nome para o condomínio').min(3, 'O nome deve ter no mínimo 3 caracteres'),
  cnpj: Yup.mixed(),
  fullAddress: Yup.object().shape<AddressShape>({
    streetName: Yup.string().required('Digite o endereço do condomínio'),
    neighborhood:  Yup.string().required('Digite o bairro do condomínio'),
    buildingNumber: Yup.string().required('Digite o número do condomínio'),
    city: Yup.string().required('Digite a cidade do condomínio'),
    postalCode: Yup.string().required('Digite o cep'),
    stateCode: Yup.string().required('Digite o estado'),
  }),
  bondCode: Yup.string().max(6, 'Código de vínculo com no máximo 6 caracteres'),
  phone: Yup.string().min(10, 'telefone inválido'),
});
